import React, { useEffect } from 'react';
import ReactModal from 'react-modal';

import { Props } from './Modal.types';
import getStyle from './Modal.style';
import styles from './Modal.module.scss';

const Modal: React.FC<Props> = ({ children, title = '', isOpen, onClose, isAutomated = false }) => {
  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  useEffect(() => {
    ReactModal.setAppElement('#root');
  }, []);

  return (
    <ReactModal
      style={getStyle(ReactModal.defaultStyles)}
      isOpen={isOpen}
      shouldCloseOnOverlayClick={!isAutomated}
      onRequestClose={handleClose}>
      <div className={styles.modalHeader}>
        <h2 className={styles.modalTitle}>{title}</h2>
        {!isAutomated && (
          <button type="button" className={styles.closeButton} onClick={handleClose}>
            x
          </button>
        )}
      </div>
      {children && <div className={styles.modalContent}>{children}</div>}
    </ReactModal>
  );
};

export default Modal;
